import { MenuItem } from "@/components/MenuItemCard";
import burgerImage from "@/assets/burger-gourmet.jpg";
import salmonImage from "@/assets/salmon-quinoa.jpg";
import saladImage from "@/assets/caesar-salad.jpg";
import dessertImage from "@/assets/chocolate-lava.jpg";
const aliMenuLogo = "/alimenu-logo-new.png";

export interface Company {
  id: string;
  name: string;
  slug: string;
  logo: string;
  logo_url?: string;
  banner_image_url?: string;
  phone: string;
  email: string;
  address: string;
  workingHours: string;
  instagram_description?: string;
  theme: {
    primaryColor: string;
    accentColor: string;
    mode?: 'light' | 'dark';
  };
  theme_mode?: 'light' | 'dark';
  layout_type?: string;
  enabled_layouts?: string[];
  // Campos individuais de endereço
  street?: string;
  number?: string;
  complement?: string;
  neighborhood?: string;
  city?: string;
  state?: string;
  zip_code?: string;
  // Campos adicionais de empresa
  legal_name?: string;
  business_type?: string;
  document_type?: string;
  document_number?: string;
  // Social media and external links
  instagram_url?: string;
  ifood_url?: string;
  website_url?: string;
  whatsapp_number?: string;
  facebook_url?: string;
  // Subscription fields
  subscription_status?: string | null;
  subscription_tier?: string | null;
  trial_ends_at?: string | null;
  current_period_end?: string | null;
  created_by_email?: string | null;
  created_by?: string;
  has_payment_method?: boolean;
  categories: Array<{
    id: string;
    name: string;
    order: number;
    image_url?: string;
  }>;
  menuItems: MenuItem[];
  menuItemsCount?: number;
  isActive: boolean;
  createdAt: Date;
}

// Mock data para múltiplas empresas
export const mockCompanies: Company[] = [
  {
    id: "1",
    name: "AliMenu Demo",
    slug: "alimenu-demo",
    logo: "",
    logo_url: aliMenuLogo,
    phone: "(11) 99999-9999",
    email: "demo@alimenu.com.br",
    address: "Rua das Flores, 123 - Centro, São Paulo - SP",
    workingHours: "Segunda a Domingo das 11h às 23h",
    layout_type: "cards",
    theme: {
      primaryColor: "#E53E3E",
      accentColor: "#C53030"
    },
    categories: [
      { id: "entradas", name: "Entradas", order: 1, image_url: saladImage },
      { id: "principais", name: "Principais", order: 2, image_url: burgerImage },
      { id: "bebidas", name: "Bebidas", order: 3 },
      { id: "sobremesas", name: "Sobremesas", order: 4, image_url: dessertImage }
    ],
    menuItems: [
      {
        id: "1",
        name: "Burger Gourmet Artesanal",
        description: "Blend de carnes nobres, queijo brie, rúcula, tomate confitado e molho especial da casa no pão brioche artesanal",
        price: 32.90,
        image: burgerImage,
        category: "principais",
        preparationTime: "20-25 min",
        tags: []
      },
      {
        id: "2",
        name: "Salmão Grelhado com Quinoa",
        description: "Salmão fresco grelhado, quinoa tricolor, legumes salteados, abacate e molho de ervas finas",
        price: 42.90,
        image: salmonImage,
        category: "principais",
        preparationTime: "15-20 min",
        tags: []
      },
      {
        id: "3",
        name: "Salada Caesar Premium",
        description: "Mix de folhas nobres, croutons artesanais, lascas de parmesão, molho caesar da casa e opcional de frango grelhado",
        price: 24.90,
        image: saladImage,
        category: "entradas",
        preparationTime: "10-15 min",
        tags: []
      },
      {
        id: "4",
        name: "Petit Gâteau de Chocolate",
        description: "Bolo de chocolate com centro cremoso, sorvete de baunilha artesanal, frutas vermelhas e calda especial",
        price: 18.90,
        image: dessertImage,
        category: "sobremesas",
        preparationTime: "12-15 min",
        tags: []
      }
    ],
    menuItemsCount: 4,
    isActive: true,
    createdAt: new Date("2024-01-15")
  },
  {
    id: "2",
    name: "Pizza Palace",
    slug: "pizza-palace",
    logo: "",
    logo_url: "",
    phone: "(11) 88888-8888",
    email: "contato@pizzapalace.com.br",
    address: "Avenida Central, 456 - Vila Madalena, São Paulo - SP",
    workingHours: "Terça a Domingo das 18h às 24h",
    theme: {
      primaryColor: "#D32F2F",
      accentColor: "#FFC107"
    },
    categories: [
      { id: "pizzas", name: "Pizzas", order: 1 },
      { id: "entradas", name: "Entradas", order: 2 },
      { id: "bebidas", name: "Bebidas", order: 3 },
      { id: "sobremesas", name: "Sobremesas", order: 4 }
    ],
    menuItems: [
      {
        id: "p1",
        name: "Pizza Margherita",
        description: "Molho de tomate especial, mussarela, manjericão fresco e azeite extra virgem",
        price: 28.90,
        image: burgerImage,
        category: "pizzas",
        preparationTime: "15-20 min",
        tags: []
      },
      {
        id: "p2",
        name: "Pizza Quattro Stagioni",
        description: "Quatro sabores em uma pizza: presunto, cogumelos, alcachofras e azeitonas",
        price: 35.90,
        image: salmonImage,
        category: "pizzas",
        preparationTime: "18-22 min",
        tags: []
      }
    ],
    menuItemsCount: 2,
    isActive: true,
    createdAt: new Date("2024-02-10")
  },
  {
    id: "3",
    name: "Café do Centro",
    slug: "cafe-do-centro",
    logo: "",
    logo_url: "",
    phone: "(11) 77777-7777",
    email: "contato@cafedocentro.com.br",
    address: "Praça da Sé, 789 - Centro, São Paulo - SP",
    workingHours: "Segunda a Sexta das 6h às 18h",
    theme: {
      primaryColor: "#8D6E63",
      accentColor: "#FFC107"
    },
    categories: [
      { id: "cafes", name: "Cafés", order: 1 },
      { id: "lanches", name: "Lanches", order: 2 },
      { id: "doces", name: "Doces", order: 3 }
    ],
    menuItems: [
      {
        id: "c1",
        name: "Café Expresso Especial",
        description: "Café torrado artesanalmente com notas de chocolate e caramelo",
        price: 8.90,
        image: dessertImage,
        category: "cafes",
        preparationTime: "3-5 min",
        tags: []
      },
      {
        id: "c2",
        name: "Sanduíche Natural",
        description: "Pão integral, peito de peru, queijo branco, alface, tomate e maionese caseira",
        price: 15.90,
        image: saladImage,
        category: "lanches",
        preparationTime: "8-10 min",
        tags: []
      }
    ],
    menuItemsCount: 2,
    isActive: true,
    createdAt: new Date("2024-03-05")
  }
];

export const findCompanyBySlug = (slug: string): Company | undefined => {
  return mockCompanies.find(company => company.slug === slug);
};
